import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components';

const Border = styled.div<{ highlightColor: string;}>`
  display: inline-flex;
  padding: 5px;
  transition: all 0.2s;
  background: ${(props: any) => props.highlightColor};
  border-radius: 6px;
  cursor: pointer;
`;

const CheckboxButton = styled.div<{ size: string, borderColor: string; }>`
  border: 1px solid ${props => props.borderColor};
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  display: flex;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
  background: white;
`;

const Check = styled.div < { color: string;}>`
  font-size: 9px;
  color: ${props => props.color};
  align-items: center;
  justify-content: center;
  display: flex;
`

type Props = {
  selected?: boolean;
  color?: string;
  size?: string;
  onClick?: (selected: boolean) => void;
};

function Checkbox({ selected, color, size = '20px', onClick }: Props) {
  const [focused, setFocused] = React.useState(false);

  return (
    <Border highlightColor={focused ? '#f6f6ff' : 'transparent'}>
      <CheckboxButton
        tabIndex={-1}
        onFocus={() => {
          setFocused(true);
        }}
        onBlur={() => {setFocused(false)}}
        size={size}
        onClick={() => {
          if (onClick) onClick(!!selected);
        }}
        borderColor={focused ? '#5d6ef8' : '#e3e4e5'}
      >
          <Check color={selected ? '#5d6ef8' : 'transparent'}>
            <FontAwesomeIcon icon={faCheck} />
        </Check>
      </CheckboxButton>
    </Border>
  );
}

export default Checkbox;
